export interface OpenFeedbackModalOptions {
  context?: Record<string, unknown>;
}

export interface ImagePreview {
  file: File;
  url?: string; // 上传成功后的 URL
  uploading?: boolean;
}

export interface FeedbackModalState {
  visible: boolean;
  context: Record<string, unknown> | null;
}

export const MAX_MESSAGE_LENGTH = 2000;
export const MAX_IMAGES = 8;
export const ACCEPTED_IMAGE_TYPES = 'image/*';

export const FeedbackSource = {
  WorkspaceTopBar: 'workspace_top_bar',
  NotificationDetail: 'notification_detail',
  SettingsMenu: 'settings_menu',
  DropdownMenu: 'dropdown_menu',
  CustomDomainDnsError: 'custom_domain_dns_error',
  ErrorMessage: 'error_message',
  CloudDashboardError: 'cloud_dashboard_error',
  SandboxStartupFailed: 'sandbox_startup_failed',
} as const;
